// extracted by mini-css-extract-plugin
export default {"table":"DataInputsSection_table__5cT8x","headerCell":"DataInputsSection_headerCell__f7A7P","cell":"DataInputsSection_cell__l17lc"};